import { Colors } from "@flatfile/design-system";
import { defaultTheme } from "../../theme.js";
import { createGlobalStyle } from "styled-components";
const BorderWidth = {
  small: "var(--turntable-cell-border-width)"
};
const GlobalBorderStyles = createGlobalStyle`
  :root {
    --turntable-cell-border-width: 1px;
  }
  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    :root {
      --turntable-cell-border-width: 0.5px;
    }
  }
`;
const border = ({
  color = Colors.Pigeon400,
  width = BorderWidth.small,
  type = "solid",
  none = false
}) => {
  if (none)
    return "none";
  return `${width} ${type} ${color};`;
};
const boxShadowBorder = ({
  color = Colors.Pigeon200,
  width = BorderWidth.small,
  type = "top"
}) => {
  if (type === "top")
    return `0 -${width} 0 0 ${color}`;
  if (type === "bottom")
    return `0 ${width} 0 0 ${color}`;
  if (type === "right")
    return `${width} 0 0 0 ${color}`;
  if (type === "bottomRight")
    return `${width} 0 0 0 ${color}, 0 ${width} 0 0 ${color}`;
  if (type === "left")
    return `-${width} 0 0 0 ${color}`;
  if (type === "all")
    return `0 0 0 ${width} ${color}`;
  return "";
};
const BoxShadowBorder = {
  top: (props = {}) => boxShadowBorder({ ...props, type: "top" }),
  bottom: (props = {}) => boxShadowBorder({ ...props, type: "bottom" }),
  right: (props = {}) => boxShadowBorder({ ...props, type: "right" }),
  bottomRight: (props = {}) => boxShadowBorder({ ...props, type: "bottomRight" }),
  left: (props = {}) => boxShadowBorder({ ...props, type: "left" }),
  all: (props = {}) => boxShadowBorder({ ...props, type: "all" })
};
const Border = {
  build: border,
  small: (props = {}) => border({ ...props, width: BorderWidth.small }),
  dashed: (props = {}) => border({ ...props, type: "dashed" }),
  status: (props = {
    theme: defaultTheme
  }) => border({
    color: props.error ? props.theme.cell.error.borderColor : props.warning ? props.theme.cell.warning.borderColor : props.theme.cell.active.borderColor,
    width: props.theme.cell.active.borderWidth
  })
};
export {
  Border,
  BorderWidth,
  BoxShadowBorder,
  GlobalBorderStyles
};
